import { Button } from '../Button';

export const AppErrorBoundary = ({ error, componentStack }) => (
    <div style={{ position: 'absolute', width: '100%', height: '100%', paddingLeft: '10vw', paddingRight: '10vw', paddingTop: '30vh' }}>
        <div>
            Oops! You have encountered an error
        </div>
        <div className='title-h3' style={{ marginTop: 20 }}>
            {error.toString()}
        </div>
        <div className='caption-text' style={{ margin: 20 }}>
            {componentStack}
        </div>
        <Button
            onClick={() => {
                window.location.href = '/';
            }}
            text="Click here to go home"
            size='big'
        />
    </div>
);
